import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { DoctorProvider } from '../../providers/doctor/doctor';

import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { ProgramDoctorsAddPage } from '../program-doctors-add/program-doctors-add';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-program-doctors',
  templateUrl: 'program-doctors.html',
})
export class ProgramDoctorsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  exportjson: any[] = [];
  displayedColumns = ['last_name', 'first_name', 'license_number', 'city', 'province', 'program_institution_id', 'clinic.name', 'fax_number', 'phone_number', 'cell_number', 'email', 'actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private dbProvider: DoctorProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      const loading = this.loadingCtrl.create({});
      loading.present();

      this.dbProvider
      .listDoctors(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((doctors) => {
        this.exportjson = doctors;
        this.dataSource = new MatTableDataSource(doctors);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        loading.dismiss();
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave program doctors view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Physicians'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'Physicians.xlsx'); // initiate a file download in browser
  }

  addeditDoctor(doctor) {
    this.navCtrl.push(ProgramDoctorsAddPage, {'doctordata': doctor});
  }

  deleteDoctor(doctor_id: string)  {
    //console.log('Delete Pharmacy: ', pharmacyId);
    let confirm = this.alertCtrl.create({
      title: "Delete Physician",
      message:
        "Are you sure you would like to delete this physician?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.dbProvider.deleteDoctor(this.program_id, doctor_id).then(() => {
              //console.log('Successfully deleted the doctor');
            })
            .catch((error) => {
              //console.log('Error deleting doctor');
            });
          }
        }
      ]
    });
    confirm.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/program-doctors/program-doctors.ts